'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _PlatformApi2 = require('./PlatformApi');

var _PlatformApi3 = _interopRequireDefault(_PlatformApi2);

var _Api = require('./Api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable sort-keys */
var endpoints = {
  facebook: {
    object: {
      one: '/facebook/{record}',
      params: {
        record: 'objectId'
      },
      queryParams: ['credential_id']
    }
  },
  pinterest: {
    adGroups: {
      contentType: _Api.CONTENT_TYPE_FORM_URLENCODED_UTF8,
      many: '/pinterest/custom/ad_groups',
      one: '/pinterest/ads/ad_groups/{record}',
      params: {
        record: 'adGroupId'
      },
      queryParams: ['campaign_ids']
    },
    campaigns: {
      contentType: _Api.CONTENT_TYPE_FORM_URLENCODED_UTF8,
      many: '/pinterest/custom/campaigns',
      one: '/pinterest/ads/campaigns/{record}',
      params: {
        record: 'campaignId'
      },
      queryParams: ['ids']
    }
  },
  newrelic: {
    backfill: {
      many: '/newrelic/backfill',
      queryParams: ['job_instance_ids', 'access_token', 'account_id']
    }
  },
  xandr: {
    advertiser: {
      one: '/xandr/advertiser',
      queryParams: ['credential_id', 'id', 'search', 'start_element', 'num_elements']
    },
    insertionOrder: {
      one: '/xandr/insertion-order',
      queryParams: ['credential_id', 'id', 'advertiser_id', 'search']
    },
    lineItem: {
      one: '/xandr/line-item',
      queryParams: ['credential_id', 'id', 'advertiser_id']
    },
    pacingStrategy: {
      one: '/xandr/pacing-strategy',
      queryParams: ['credential_id', 'line_item_id']
    },
    profile: {
      one: '/xandr/profile',
      queryParams: ['credential_id', 'advertiser_id', 'member_id']
    }
  }
  /* eslint-enable sort-keys */

};var defaultOptions = {
  auth: {
    accessToken: null,
    adAccountId: null,
    credentialId: null
  },
  headers: {},
  prefix: '/social'
};

var SocialApi = function (_PlatformApi) {
  (0, _inherits3.default)(SocialApi, _PlatformApi);

  function SocialApi(options) {
    (0, _classCallCheck3.default)(this, SocialApi);

    var o = (0, _assign2.default)({}, defaultOptions, options);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SocialApi.__proto__ || (0, _getPrototypeOf2.default)(SocialApi)).call(this, o));

    _this._endpoints = endpoints;
    return _this;
  }

  (0, _createClass3.default)(SocialApi, [{
    key: 'buildFetch',
    value: function buildFetch(method) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/json';

      var _get$call = (0, _get3.default)(SocialApi.prototype.__proto__ || (0, _getPrototypeOf2.default)(SocialApi.prototype), 'buildFetch', this).call(this, method, state, contentType),
          headers = _get$call.headers,
          validMethod = _get$call.method;

      return { headers: (0, _assign2.default)(headers, this._options.headers), method: validMethod };
    }
  }, {
    key: 'buildQueryParams',
    value: function buildQueryParams(name) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var params = (0, _get3.default)(SocialApi.prototype.__proto__ || (0, _getPrototypeOf2.default)(SocialApi.prototype), 'buildQueryParams', this).call(this, name, state);

      var auth = this._options.auth;

      var accessToken = auth.accessToken;
      var credentialId = auth.credentialId;

      if (accessToken) {
        params.push('access_token=' + accessToken);
      }

      // TODO remove this block after moving platformApi logic to socialApi
      if (credentialId) {
        // Remove credentialId from params then add credential_id because
        // There is a mismatch between credentialId in PlatformApi and SocialApi
        params = params.filter(function (param) {
          return param.indexOf('credentialId') < 0;
        });
        params.push('credential_id=' + credentialId);
      }

      return params;
    }
  }]);
  return SocialApi;
}(_PlatformApi3.default);

exports.default = SocialApi;
//# sourceMappingURL=SocialApi.js.map